<div mat-dialog-title class="title">
  <mat-icon fontIcon="delete"></mat-icon>
  {{'form.deletion'|translate}}
</div>

<mat-dialog-content>
  {{'delete_confirm'|translate}}
  <p>{{data.title}} {{data.name}}</p>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <lib-button (click)="onCancel()" text="{{'form.cancel'|translate}}" color="outline" icon="close"></lib-button>

  <lib-button (click)="onDelete()" color="danger" text="{{'form.delete'|translate}}" icon="delete"></lib-button>
</mat-dialog-actions>